import { Box, Checkbox, DialogActions, makeStyles, Paper, TextField, Tooltip } from '@material-ui/core';
import { Commute } from '@material-ui/icons';
import { useNavigate } from 'react-router';
import { Box as MuiBox, Button, Chip, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import Title from '../../../components/Title';
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import { useEffect, useRef, useState } from 'react';
import Spacer from '../../../components/Spacer';
import KilometersMissionService from '../../../services/KilometersMissionService';
import Message from '../../tools/Message';
import { DataGrid } from '@mui/x-data-grid';
import MissionOrderService from '../../../services/MissionOrderService';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import DescriptionIcon from '@mui/icons-material/Description';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "hidden",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px",
    marginTop: "2%",
    height: "60%",
    boxShadow: "box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
  },
}));

const formatGridDate = (value) => {
  if (!value) return '—';

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('fr-FR');
};

const renderWrappedCell = (params) => (
  <MuiBox
    sx={{
      width: '100%',
      py: 1.25,
      whiteSpace: 'normal',
      overflowWrap: 'anywhere',
      lineHeight: 1.4,
    }}
  >
    {params.value || '—'}
  </MuiBox>
);

const renderThreeLineCell = (params) => (
  <Tooltip title={params.value || ''} placement="top-start" arrow>
    <MuiBox
      sx={{
        width: '100%',
        py: 1.25,
        lineHeight: 1.4,
        overflowWrap: 'anywhere',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {params.value || '—'}
    </MuiBox>
  </Tooltip>
);

const MissionVehicleTable = (props) => {
  const {
    rows,
    handleSelectAllChange,
    selectedMissions,
    setSelectedMissions,
    setOpenDialogAssignment,
    handleRowClick,
    setActivateTransport,
    handleShowEditDialog,
    selectAll,
    setColumns,
    setRowToConfirm,
  } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const scrollbarHauteRef = useRef(null);
  const conteneurTableauRef = useRef(null);
  const [openEmptyKilometer, setOpenEmptyKilometer] = useState({
      open: false,
      missionData: null,
    }); // pour la confirmation de l'absence de kilométrage*
  const [sendMailOpen, setSendMailOpen] = useState(false);
  const [observation, setObservation] = useState('');
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [detailsDialog, setDetailsDialog] = useState({
    open: false,
    missionData: {},
  });
     function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  useEffect(() => {
    setColumns(columns);
  }, [rows])
  
        const isTransportConfirmed = (row) => {
          const vehicles = Array.isArray(row.vehicles) ? row.vehicles : [];
          const transportManagementTrue = row.transport_management === 'true';
          const allVehiclesConfirmed = vehicles.length > 0 && vehicles.every(
            (v) => v.transport_state === "CONFIRMED"
          );
          return transportManagementTrue || allVehiclesConfirmed;
        };
     const STATE_FUEL = [
    { label: 'Nouveau', value: "NEW", color: '#33ccff' },
    { label: 'En attente de confirmation', value: 'PENDING', color: 'purple' },
    { label: 'Confirmé', value: 'CONFIRMED', color: 'green' },
    { label: 'Refusé', value: 'REFUSED', color: 'red' },
    { label: 'Tous', value: '', color: '#33ccff' }
  ];

  const handleCheckboxChange = (mission) => {
    setSelectedMissions((prevSelected) =>
      prevSelected.some((m) => m.id === mission.id)
        ? prevSelected.filter((m) => m.id !== mission.id)
        : [...prevSelected, mission]
    );
  };

  const isSuccessfulStatus = (statusValue) => {
    if (statusValue === true || statusValue === 1 || statusValue === "1") {
      return true;
    }
    if (typeof statusValue === "string") {
      const normalized = statusValue.trim().toUpperCase();
      return normalized === "TRUE" || normalized === "SUCCESS" || normalized === "OK";
    }
    return false;
  };

  const resolveDriverOmUrl = (rawUrl) => {
    if (!rawUrl) {
      return "";
    }
    const asString = String(rawUrl).trim();
    if (!asString) {
      return "";
    }
    if (/^https?:\/\//i.test(asString)) {
      return asString;
    }
    const cleanPath = asString.replace(/^\/+/, "");
    const configuredApiUrl = process.env.REACT_APP_API_URL || "";
    if (configuredApiUrl) {
      try {
        const api = new URL(configuredApiUrl);
        return `${api.protocol}//${api.host}/${cleanPath}`;
      } catch (error) {
        return `/${cleanPath}`;
      }
    }
    return `/${cleanPath}`;
  };

  const handleDownloadDriverOM = async (mission_planning_id, mission_planning_agenda_id) => {
    try {
      const response = await MissionOrderService.downloadDriverOM(
        mission_planning_id,
        mission_planning_agenda_id
      );

      if (!response || !isSuccessfulStatus(response.status)) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: response?.message || "Erreur lors du telechargement de l'OM chauffeur."
        });
        return;
      }

      let files = [];
      if (Array.isArray(response?.data?.files)) {
        files = response.data.files;
      } else if (Array.isArray(response?.files)) {
        files = response.files;
      } else if (response?.data?.file_url) {
        files = [response.data];
      } else if (response?.file_url) {
        files = [response];
      }

      if (!files.length) {
        setMessage({
          open: true,
          color: 'orange',
          messageInfo: "Aucun fichier OM chauffeur disponible pour cette mission."
        });
        return;
      }

      let downloadedCount = 0;

      for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        const fileUrl = resolveDriverOmUrl(file?.file_url || file?.download_url || file?.url);
        if (!fileUrl) {
          continue;
        }

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = file?.file_name || `om_chauffeur_${mission_planning_id}_${i + 1}.pdf`;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        downloadedCount += 1;
        await new Promise((resolve) => setTimeout(resolve, 120));
      }

      if (!downloadedCount) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: "Echec du telechargement des fichiers OM chauffeur."
        });
        return;
      }

      setMessage({
        open: true,
        color: 'green',
        messageInfo: `${downloadedCount} fichier(s) OM chauffeur telecharge(s) avec succes.`
      });
    } catch (error) {
      console.error("Erreur lors du telechargement de l'OM chauffeur :", error);
      setMessage({ open: true, color: 'red', messageInfo: "Erreur lors du telechargement de l'OM chauffeur." });
    }
  };

  const handleDownloadProvisionalFuel = async (provisional_fuel_id) => {
    if (!provisional_fuel_id) {
      setMessage({
        open: true,
        color: 'red',
        messageInfo: 'Identifiant du carburant previsionnel introuvable.'
      });
      return;
    }

    let fileURL = null;

    try {
      const response = await ProvisionalFuelMissionService.downloadValidatedProvisionalFuelZip(
        provisional_fuel_id
      );

      if (!response) {
        throw new Error('Reponse de telechargement vide.');
      }

      const zipBlob = response instanceof Blob
        ? response
        : new Blob([response], { type: 'application/zip' });

      if (zipBlob.type && zipBlob.type.includes('application/json')) {
        let errorMessage = 'Fichier ZIP de carburant previsionnel introuvable.';
        try {
          const errorResponse = JSON.parse(await zipBlob.text());
          errorMessage = errorResponse?.message || errorMessage;
        } catch (parseError) {
          console.error('Erreur lors de la lecture de la reponse de telechargement :', parseError);
        }
        setMessage({ open: true, color: 'red', messageInfo: errorMessage });
        return;
      }

      if (!zipBlob.size) {
        throw new Error('Le fichier ZIP est vide.');
      }

      fileURL = window.URL.createObjectURL(zipBlob);
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', `ProvisionalFuel_${provisional_fuel_id}.zip`);
      document.body.appendChild(fileLink);
      fileLink.click();
      document.body.removeChild(fileLink);

      setMessage({
        open: true,
        color: 'green',
        messageInfo: 'Carburant previsionnel telecharge avec succes.'
      });
    } catch (error) {
      console.error('Erreur lors du telechargement du carburant previsionnel :', error);
      setMessage({
        open: true,
        color: 'red',
        messageInfo: 'Erreur lors du telechargement du carburant previsionnel.'
      });
    } finally {
      if (fileURL) {
        window.URL.revokeObjectURL(fileURL);
      }
    }
  }

const columns = [
                  {
                    field: 'reference',
                    headerName: 'Référence',
                    width: 135,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => (
                      <MuiBox sx={{ fontWeight: 700, color: '#29476f' }}>
                        {params.value || '—'}
                      </MuiBox>
                    ),
                  },
                  {
                    field: 'mission_title',
                    headerName: 'Objet de la mission',
                    flex: 1.3,
                    minWidth: 280,
                    renderCell: renderThreeLineCell,
                  },
                  {
                    field: 'lieu',
                    headerName: 'Destination',
                    flex: 0.8,
                    minWidth: 190,
                    renderCell: renderWrappedCell,
                  },
                  {
                    field: 'date_begin',
                    headerName: 'Date de début',
                    width: 125,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => formatGridDate(params.value),
                  },
                  {
                    field: 'date_end',
                    headerName: 'Date de fin',
                    width: 125,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => formatGridDate(params.value),
                  },
                 {
                        field: 'users',
                        headerName: 'Missionnaires',
                        flex: 1,
                        minWidth: 240,
                        renderCell: (params) => {
                          if (params.row.categtype === "groupe") {
                            return (
                              <Chip
                                label="Mission groupée"
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ fontWeight: 600 }}
                              />
                            );
                          }

                          const missionnaries = Array.isArray(params.row.users) ? params.row.users : [];
                          const missionnariesLabel = missionnaries
                            .map((missionnary) => missionnary.nom)
                            .filter(Boolean)
                            .join(', ');
                          return (
                            <Tooltip title={missionnariesLabel} placement="top-start" arrow>
                              <MuiBox
                                sx={{
                                  width: '100%',
                                  height: '100%',
                                  py: 1,
                                  boxSizing: 'border-box',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 0.5,
                                  overflow: 'hidden',
                                }}
                              >
                                {missionnaries.length > 0 ? missionnaries.map((missionnary, index) => (
                                  <MuiBox
                                    key={missionnary.user_id || `${missionnary.nom}-${index}`}
                                    sx={{ display: 'flex', alignItems: 'flex-start', lineHeight: 1.35 }}
                                  >
                                    <MuiBox component="span" sx={{ color: 'primary.main', mr: 0.75, fontWeight: 700 }}>
                                      •
                                    </MuiBox>
                                    <MuiBox component="span" sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                                      {missionnary.nom || '—'}
                                    </MuiBox>
                                  </MuiBox>
                                )) : '—'}
                              </MuiBox>
                            </Tooltip>
                          );
                        }
                      },
                 {
                  field: 'vehicle',
                  headerName: 'Voiture(s)',
                  flex: 0.75,
                  minWidth: 190,
                  renderCell: (params) => {
                    const vehicles = Array.isArray(params.row.vehicles) ? params.row.vehicles : [];
                    const vehiclesLabel = vehicles
                      .map((vehicle) => vehicle.vhc_imm != null
                        ? `${vehicle.vhc_imm} (${vehicle.vhc_type || '—'})`
                        : 'Location')
                      .join(', ');
                    return (
                      <Tooltip title={vehiclesLabel} placement="top-start" arrow>
                        <MuiBox
                          sx={{
                            width: '100%',
                            height: '100%',
                            py: 1,
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 0.5,
                            overflow: 'hidden',
                          }}
                        >
                          {vehicles.length > 0 ? vehicles.map((vehicle, index) => (
                            <MuiBox
                              key={vehicle.transport_id || vehicle.vhc_id || `${vehicle.vhc_imm}-${index}`}
                              sx={{ display: 'flex', alignItems: 'flex-start', lineHeight: 1.35 }}
                            >
                              <MuiBox component="span" sx={{ color: 'primary.main', mr: 0.75, fontWeight: 700 }}>
                                •
                              </MuiBox>
                              <MuiBox component="span" sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                                {vehicle.vhc_imm != null
                                  ? `${vehicle.vhc_imm} (${vehicle.vhc_type || '—'})`
                                  : 'Location'}
                              </MuiBox>
                            </MuiBox>
                          )) : '—'}
                        </MuiBox>
                      </Tooltip>
                    );
                  },
                },
                  {
                    field: 'mission_timesheet_state',
                    headerName: 'Timesheet',
                    width: 140,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => (
                      <MuiBox sx={{ width: '100%', py: 1, display: 'flex', justifyContent: 'center' }}>
                        {['PENDING', 'CONFIRMED'].includes(params.row.mission_timesheet_state) ? (
                          <Button
                            variant='contained'
                            color={params.row.mission_timesheet_state === 'PENDING' ? 'secondary' : 'success'}
                            size='small'
                            onClick={() => handleShowTimesheet(params.row)}
                          >
                            {params.row.mission_timesheet_state === 'PENDING' ? 'OUI' : 'Validé'}
                          </Button>
                        ) : (
                          <Button
                            variant='contained'
                            size='small'
                            sx={{ backgroundColor: params.row.mission_timesheet_state === 'REFUSED' ? "red" : "#8c8c8c" }}
                            onClick={() => handleShowEmptyKilometer(params.row)}
                          >
                            {params.row.mission_timesheet_state === 'REFUSED' ? 'Refusé' : 'NON'}
                          </Button>
                        )}
                      </MuiBox>
                    )
                  },
                  {
                    field: 'action',
                    headerName: 'Action',
                    width: 210,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => {
                      const row = params.row;
                      return (
                        <MuiBox sx={{ width: '100%', py: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
                          {(!isTransportConfirmed(row) && row.mission_timesheet_state === "PENDING") && Number(row.is_request) === 0 && (
                            <>
                              <IconButton
                                color='info'
                                title="Gérer transport par ligne de l'agenda"
                                onClick={() => handleShowTimesheet(row, { openTransportDialog: true })}
                              >
                                <Commute />
                              </IconButton>
                            </>
                          )}
                          {(!isTransportConfirmed(row) && row.mission_timesheet_state === "PENDING") && Number(row.is_request) === 1 && (
                            <IconButton color='info' title="Gérer transport par ligne de l'agenda" onClick={() => navigate(`/Logistic/mission/transport_managment/reply/${row.mission_planning_id}`)}>
                              <Commute />
                            </IconButton>
                          )}
                          {(!isTransportConfirmed(row) && row.mission_timesheet_state === "PENDING") && Number(row.is_request) === 0 && (
                            <Button
                              title="Solliciter une voiture à une autre direction"
                              onClick={() => handleShowTimesheet(row, { openSolicitationDialog: true })}
                              size="small"
                              variant="outlined"
                              color='warning'
                            >
                              Solliciter
                            </Button>
                          )}

                          {(isTransportConfirmed(row) || row.mission_timesheet_state === "CONFIRMED") && (
                             <Button
                              title="Réactiver la gestion du transport"
                              variant="outlined"
                              size='small'
                              color='error'
                              startIcon={<UndoIcon color='error' />}
                              onClick={() => setActivateTransport({ open: true, mission_id: row.mission_planning_id, mission_planning_agenda_id: row.mission_planning_agenda_id, mission_timesheet_id: row.mission_timesheet_id })}
                            >
                              Réactiver
                            </Button>
                          )}
                        </MuiBox>
                      );
                    }
                  },
                  {
                    field: 'OM_driver',
                    renderHeader: () => (
                      <Typography sx={{ fontWeight: 'bold', fontSize: '11px', textAlign: 'center' }}>
                        Timesheet <br/>/ OM Chauffeur
                      </Typography>
                    ),
                    headerName: 'Timesheet/OM Chauffeur',
                    width: 125,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => (
                      <MuiBox sx={{ width: '100%', py: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{((params.row.vehicles || []).filter(v => v.vhc_type === "FID").length !== 0 && params.row.mission_timesheet_state === "CONFIRMED") &&
                      <Tooltip title="Télécharger l'OM chauffeur" placement="top">
                      <IconButton variant="outlined" color="yellow" title="Télécharger  le chauffeur OM" onClick={() => handleDownloadDriverOM(params.row.mission_planning_id, params.row.mission_planning_agenda_id)}>
                          <DescriptionIcon />
                        </IconButton></Tooltip>}</MuiBox>
                    ),

                  },
                    {
                    field: 'provisional_fuel_id',
                    cellClassName: "borderLeftCell",
                    headerName: 'Carburant prévisionnel',
                    renderHeader: () => (
                      <Typography sx={{ fontWeight: 'bold', fontSize: '11px', textAlign: 'center' }}>
                        Carburant <br/>prévisionnel
                      </Typography>
                    ),
                    width: 155,
                    headerAlign: 'center',
                    align: 'center',
                    renderCell: (params) => (
                      
                        params.row.mission_timesheet_state === "CONFIRMED"  && (
                      
                       <MuiBox sx={{ width: '100%', py: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          { params.row.provisional_fuel_state !== "CONFIRMED" && (() => { const state = STATE_FUEL.find((option) => option.value === params.row.provisional_fuel_state);
        return (
          <Chip
            label={state?.label || 'Nouveau'}
            size="small"
            variant="outlined"
            sx={{
              maxWidth: '100%',
              color: state?.color || '#33ccff',
              borderColor: state?.color || '#33ccff',
              fontWeight: 600,
              '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
            }}
          />
        );})()}
                   { params.row.provisional_fuel_state === "CONFIRMED" &&   <IconButton
                        variant="outlined"
                        color='secondary'
                        title="Télécharger le carburant prévisionnel"
                        onClick={() => handleDownloadProvisionalFuel(params.row.provisional_fuel_id)}
                      >
                        <TextSnippetIcon />
                      </IconButton>
                    }
                      </MuiBox>
                    ) )
                      
                  }
                ];

  const largeurMinimaleTableau = columns.reduce(
    (largeur, colonne) =>
      largeur +
      (typeof colonne.width === 'number'
        ? colonne.width
        : typeof colonne.minWidth === 'number'
          ? colonne.minWidth
          : 100),
    24
  );

  const synchroniserScrollHorizontal = (event, cibleRef) => {
    const cible = cibleRef.current;
    const position = Math.round(event.currentTarget.scrollLeft);

    if (cible && Math.abs(cible.scrollLeft - position) >= 1) {
      cible.scrollLeft = position;
    }
  };

    const handleShowTimesheet = (missionData, options = {}) => {
    const { openTransportDialog = false, openSolicitationDialog = false } = options;
    navigate(
      `/Logistic/mission/timesheet/validate/${missionData.mission_planning_id}/${missionData.mission_planning_agenda_id}/${missionData.mission_timesheet_id || 0}`,
      {
        state: {
          mission_timesheet_state: missionData.mission_timesheet_state,
          mission_timesheet_user_id: missionData.mission_timesheet_user_id,
          openTransportDialog,
          openSolicitationDialog,
          from: '/Logistic/mission/timesheet',
        },
      }
    );
    setOpenDialogAssignment({ open: false, isEdit: false });
  }
  
  const handleShowEmptyKilometer = (missionData) => {
    setOpenEmptyKilometer({
      open: true,
      missionData: missionData,
    });
  }

  const handleSendRequestKilometer = async (missionData) => {
    try {
      const response = await KilometersMissionService.sendRequestKilometerMission(missionData.mission_planning_id, missionData.mission_planning_destination_id, missionData.mission_planning_agenda_id, observation);
      if (response && response.status) {
        setSendMailOpen(false);
        setOpenEmptyKilometer({ open: false, missionData: null });
        setObservation('');
        setMessage({ open: true, color: 'green', messageInfo: "La demande d'élaboration de timesheet a été envoyée avec succès."  });
      } else {
        const errorMsg = response && response.message ? response.message : "Erreur lors de l'envoi de la demande de saisie des kilométrages.";
        setMessage({open: true, color: 'error', messageInfo: errorMsg });
      }
    }catch (error) {
      console.error("Erreur lors de l'envoi de la demande d'élaboration de timesheet :", error);
      setMessage({ open: true, color: 'error', messageInfo: "Erreur lors de l'envoi de la demande d'élaboration de timesheet." });
    }
  }

  return (
    <>
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <Paper className={classes.paper} variant="outlined">
          <Title>Gestion des transports des missionnaires </Title>
        <Box
          ref={scrollbarHauteRef}
          onScroll={(event) =>
            synchroniserScrollHorizontal(event, conteneurTableauRef)
          }
          style={{
            width: '100%',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <Box
            style={{
              width: largeurMinimaleTableau,
              height: 1,
            }}
          />
        </Box>
        <Box
          ref={conteneurTableauRef}
          onScroll={(event) =>
            synchroniserScrollHorizontal(event, scrollbarHauteRef)
          }
          style={{
            width: '100%',
            minWidth: 0,
            overflowX: 'auto',
            overflowY: 'hidden',
          }}
        >
          <Box
            style={{
              height: 600,
              width: '100%',
              minWidth: largeurMinimaleTableau,
            }}
          >
            <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  page: 0,
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            rowHeight={84}
            onRowDoubleClick={(params, event) => handleRowClick(params, event)}
              getRowClassName={(params) =>
                  selectedMissions.some((m) => m.id === params.row.id) ? 'custom-selected' : ''
                }
                sx={{
                  border: 0,
                  color: '#334155',
                  fontSize: '12px',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f4f7fb',
                    borderBottom: '1px solid #dce6f3',
                    color: '#29476f',
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 700,
                    whiteSpace: 'normal',
                    lineHeight: 1.25,
                  },
                  '& .MuiDataGrid-row': {
                    minHeight: '84px !important',
                    maxHeight: '84px !important',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: '#f8fbff',
                  },
                  '& .MuiDataGrid-row.custom-selected': {
                    backgroundColor: '#e8f1f5 !important',
                  },
                  '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '84px !important',
                    maxHeight: '84px !important',
                    py: 0.5,
                    whiteSpace: 'normal',
                    lineHeight: 1.4,
                    borderColor: '#edf1f7',
                    overflow: 'hidden',
                  },
                  '& .MuiDataGrid-cellContent': {
                    width: '100%',
                    whiteSpace: 'normal',
                    lineHeight: 1.4,
                    overflowWrap: 'anywhere',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: '1px solid #dce6f3',
                  },
                }}
            disableSelectionOnClick />
          </Box>
        </Box>
      </Paper> 
      <Dialog
        open={openEmptyKilometer.open}
        onClose={() => setOpenEmptyKilometer({ open: false, missionData: null })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
           <Typography> La timesheet n'est pas encore élaborée. </Typography>  
          </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description" textAlign='center' display='flex' flexDirection='column' alignItems='center'>
           <Grid container justifyContent='center' alignItems='center' marginTop={2}>
            <Spacer y={2} />
             <Button variant='contained' color='info' onClick={() => {
              handleShowTimesheet(openEmptyKilometer.missionData)
              setOpenEmptyKilometer({ open: false})
              }} startIcon={<EditIcon />}>
              Elaborer la timesheet
            </Button>
            </Grid>
            <Spacer y={1} /> 
            <Grid container justifyContent='center' alignItems='center' marginTop={2}>
            <Button variant='contained' color='success'  startIcon={<SendIcon />} style={{ marginLeft: '10px' }} onClick={() => {setSendMailOpen(true)}}>
             Envoyer une demande de saisie
            </Button>
            </Grid>
            <Spacer y={1} />
            <Grid container justifyContent='center' alignItems='center' marginTop={2}>
              <Button variant='contained' color='error' onClick={() => setOpenEmptyKilometer({ open: false, missionData: null })}>
              Fermer
            </Button>
            </Grid>
          </DialogContentText>       
        </DialogContent>
        </Dialog>
         <Dialog
        open={sendMailOpen}
        onClose={() =>{ setOpenEmptyKilometer({ open: false, missionData: null }); setSendMailOpen(false); setObservation('');}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
         maxWidth="sm"
        fullWidth
        >
          <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
           <Typography> Envoyer une demande de saisie </Typography>  
          </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description" display='flex' flexDirection='column'>
            <label> (Un email sera envoyé aux missionnaires concernés)</label>
            <label>Observation : </label>
            <TextField
              autoFocus
              margin="dense"
              id="observation"
              type="text"
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
            />
          </DialogContentText>       
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenEmptyKilometer({ open: false, missionData: null }); setSendMailOpen(false); setObservation('')}} color="primary" variant='outlined'>
            Annuler
          </Button>
          <Button onClick={() => {
              handleSendRequestKilometer(openEmptyKilometer.missionData);
            }} color="primary" variant='contained'>
            Envoyer
          </Button>
          </DialogActions>
        </Dialog>

      </>
  );
};

export default MissionVehicleTable;

